import React from 'react';
import { RestrictedComponent } from '../../ui-components/RestrictedComponent';
import { SearchPage } from './SearchPage';

export const SearchPageWrapper = () =>
  <RestrictedComponent permission='search_product' message='NOT PERMITTED'>
    <SearchPage />
  </RestrictedComponent>;

